"use client";

import { useState } from "react";

import { EnterprisePlan } from "@/components/pricing/EnterprisePlan";
import { MonthlyRadio } from "@/components/pricing/MonthlyRadio";
import { PricingCard } from "@/components/pricing/PricingCard";
import { PricingFaq } from "@/components/pricing/PricingFaq";
import { pricePlans } from "@/constants/pricePlans";
import { UserNoDates } from "@/types/types";
import { isFreeUser } from "@/utils/subscriptionLevels/isFreeUser";

export function PricingContent({
  user,
  numberOfModels,
  closeModal,
}: {
  user: UserNoDates | null;
  numberOfModels: number;
  closeModal: (() => void) | null;
}) {
  const freeUser = user === null || isFreeUser(user.stripeSubscriptionId);

  const [monthly, setMonthly] = useState(!freeUser);

  return (
    <>
      <div className="mb-10 flex justify-center">
        <MonthlyRadio monthly={monthly} setMonthly={setMonthly} />
      </div>

      <div className="mb-16 flow-root lg:mb-10">
        <div className="isolate grid grid-cols-1 gap-y-16 divide-gray-100 sm:mx-auto sm:grid-cols-2 lg:grid-cols-4 lg:divide-x">
          {pricePlans.map((pricePlan) => (
            <PricingCard
              key={pricePlan.name}
              pricePlan={pricePlan}
              user={user}
              monthly={monthly}
              numberOfModels={numberOfModels}
              closeModal={closeModal}
            />
          ))}
        </div>
      </div>

      <EnterprisePlan />

      <PricingFaq />
    </>
  );
}
